export default __webpack_public_path__ + "static/media/car3.4a3ba3ef.png";